import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Rounter, Routes, Route, Switch, Link, Outlet } from 'react-router-dom';

const ShowCate = (props) => {
    const { listCate } = props;
    return (
        <div className="catenav_list">
            {listCate.map((cate, index) => {
                return (
                    <React.Fragment key={cate.id}>
                        <div className="catenav_listitem">
                            <Link to={`/cate/${cate.id}`}>{cate.name}</Link>
                        </div>
                    </React.Fragment>
                );
            })}
        </div>
    );
};

const Header = () => {
    const [listCate, setListCate] = useState([]);
    const getCate = () => {
        axios.get(`http://hoanlam.webstarterz.com/hoanlam.webstarterz.com/wp-json/wp/v2/categories`)
        .then((res) => {
            setListCate(res.data);
        })
        .catch((err) => {
            alert("Không thể kết nối server");
        })
        .finally(() => {
        });
    };
    useEffect(() => {
        getCate();
    }, [])
    return (
        <div className="header">
            <div className="container flexbox">
                <div className="logo">
                    <Link to={`/`}>Maru</Link>
                </div>
                <div className="catenav">
                    <div className="catenav_btn">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                    <ShowCate listCate={listCate} />
                </div>
            </div>
        </div>
    );
}

export default Header